import { addUser } from '../../api/admin';
import invalidationManager from './InvalidationManager';

const useAddUserMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, email: string, password?: string) => {
    await addUser(companyId, email, password);
    await invalidationManager.invalidate(['company', companyId, 'users']);
  },
});

export { useAddUserMutation };
